import React, { useContext, useEffect, useState } from "react";
import "./styles/ActivitiesCard.scss";
import ScriptBoxCaller from "../ScriptBoxCaller/ScriptBoxCaller";
import SheetActivityItem from "../../views/ProjectSheet/SheetActivityItem/SheetActivityItem";
import { getService } from "../../services/axios/services";
import AppContext from "../../context/appContext";
import ActivitiesCompletedModal from "../../views/ProjectSheet/ActivitiesCompletedModal/ActivitiesCompletedModal";
import SmallLoading from "../SmallLoading/SmallLoading";

const ActivitiesCard = (props) => {
  const { cardTitle, contentType, format, projectId } = props;
  const appContext = useContext(AppContext);

  const [state, setState] = useState({ loading: true, list: [] });

  const getProjectActivities = () => {
    getService({
      endpoint: `projects/${projectId}/activities`,
      params: {
        types: [1, 2, 3, 4],
        status: 6,
        limit: 9999,
      },
    }).then((response) => {
      setState({
        loading: false,
        list: response.data,
      });
    });
  };

  useEffect(() => {
    getProjectActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state.loading)
    return (
      <div className="centerLoading">
        <SmallLoading />
      </div>
    );

  return (
    <div className="infoCard">
      <div className="cardHeader">
        <span className="cardTitle">{cardTitle}</span>
      </div>

      {!!state.list.length ? (
        state.list.slice(0, 3).map((item, index) => {
          return (
            <SheetActivityItem
              key={index}
              item={item}
              contentType={contentType}
              format={format}
              openLinksInNewTab
            />
          );
        })
      ) : (
        <div className="cardContent">
          <span>Não há nenhuma atividade.</span>
        </div>
      )}

      {state.list.length > 3 && (
        <div className="cardContent">
          <div className="allAttachments">
            <ScriptBoxCaller
              callerText="Ver todas as atividades"
              event={() =>
                appContext.setCurrentStepBox("activitiesAttachments")
              }
            />
          </div>
        </div>
      )}

      {appContext.current.step === "activitiesAttachments" && (
        <ActivitiesCompletedModal
          open={appContext.current.step === "activitiesAttachments"}
          onClose={() => appContext.setCurrentStepBox("closed")}
          activities={state.list}
          contentType="dramaturgia"
          format={format}
        />
      )}
    </div>
  );
};

export default ActivitiesCard;
